<div class="chipComponent">
    <div class="chipComponent-label">
        {{label}}
    </div>
    <button (click)="onClick($event)"
            [hidden]="!isClosable">
        <i class="fas fa-plus"></i>
    </button>
</div>
